import { useQuery } from '@tanstack/react-query';
import { configControllerGetPublicTenantConfigQueryOptions } from '../../generated/kubb';

export function useAvailableProductIds(): string[] {
  const { data } = useQuery({
    ...configControllerGetPublicTenantConfigQueryOptions(),
    staleTime: 5 * 60 * 1000,
  });

  return data?.availableProductIds ?? [];
}
